import { render } from "./TabPublish.vue?vue&type=template&id=4c00a968"
import script from "./TabPublish.vue?vue&type=script&setup=true&lang=js"
export * from "./TabPublish.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ui/StreamSidebar/TabPublish.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c00a968"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c00a968', __exports__)) {
    api.reload('4c00a968', __exports__)
  }
  
  module.hot.accept("./TabPublish.vue?vue&type=template&id=4c00a968", () => {
    api.rerender('4c00a968', render)
  })

}


export default __exports__